// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContestRules{box-sizing:border-box}.ContestRules .heading{color:#222}.darkmode .ContestRules .heading{color:#fff}.ContestRules .endLine{margin-top:40px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
